import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface IPaymentAttemptedPayload {
  bookingId: string;
  correlationId: string;
}

export const PAYMENT_ATTEMPTED_EVENT_TYPE = 'PaymentAttempted';

export class PaymentAttemptedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = PAYMENT_ATTEMPTED_EVENT_TYPE;

  constructor(public readonly payload: IPaymentAttemptedPayload) {
  }
}
